import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '../../../components/ndoe';
import FormCommande from '../formCommande/FormCommande';
import CommandeWizard from './CommandeWizard';

// Vrai dans l'APK (WebView Capacitor).
const estNatif = () => !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());

/**
 * Aiguillage de « Nouvelle commande » : sur APK (natif) OU petit écran, on sert
 * le WIZARD mobile guidé (demande proprio 21/07) ; sur desktop web, le formulaire
 * classique reste inchangé. Périmètre validé : « mobile / APK d'abord ».
 */
export default function NouvelleCommande() {
  const navigate = useNavigate();
  const petitEcran = useMediaQuery('(max-width: 768px)');
  if (estNatif() || petitEcran) {
    return <CommandeWizard onClose={() => navigate('/listeCommande')} />;
  }
  return <FormCommande />;
}
